export default {
  "A confirmation code has just been sent to you by message": "Er is zojuist een bevestigingscode naar u verzonden per bericht",
  "Already have an account": "Heb al een account",
  "Beyond this time, the reservation we retain will be available again for others": "Na deze tijd zal de reservering die wij behouden weer beschikbaar zijn voor anderen",
  "Book now": "Boek nu",
  "Booking": "Boeking",
  "Booking information": "Boekingsinformatie",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "Boeking begint de eerste dag om {startTime} en eindigt de laatste dag om {endTime}",
  "Cancel booking": "Boeking annuleren",
  "Choose your date": "Kies uw datum",
  "Confirm my phone number": "Bevestig mijn telefoonnummer",
  "Confirm my registration": "Bevestig mijn registratie",
  "Confirm my registration and pay": "Bevestig mijn inschrijving en betaal",
  "Continue as guest": "Ga door als gast",
  "Continue to registration": "Ga verder naar registratie",
  "Create an account": "Account aanmaken",
  "Dates": "Datums",
  "End Date of Reservation": "Einddatum van reservering",
  "Enlarge map": "Vergroot kaart",
  "Enter your code here to confirm your registration": "Voer hier uw code in om uw registratie te bevestigen",
  "I accept the Terms and conditions of registration": "Ik accepteer de Algemene voorwaarden voor registratie",
  "Loading…": "Bezig met laden…",
  "Location": "Plaats",
  "More information": "Meer informatie",
  "No slots available": "Geen slots beschikbaar",
  "Processing booking…": "Boeking verwerken…",
  "Processing payment…": "Betaling verwerken…",
  "Product": "Product",
  "Recording payment…": "Betaling registreren…",
  "Reduce map": "Kaart verkleinen",
  "Remaining time": "Overgebleven tijd",
  "Required fields": "Verplichte velden",
  "Reserving a product is mandatory for registration": "Voor registratie is het reserveren van een product verplicht",
  "Retrieving available slots": "Beschikbare slots ophalen",
  "Saving registration…": "Registratie opslaan…",
  "Select size first": "Selecteer eerst de maat",
  "Select stage first": "Selecteer eerst fase",
  "Select your options and dates to book": "Selecteer uw opties en data om te boeken",
  "Size": "Maat",
  "Slot": "Sleuf",
  "Stage": "Fase",
  "Store": "Winkel",
  "Start Date of Reservation": "Startdatum van reservering",
  "View terms and conditions": "Bekijk de algemene voorwaarden",
  "You do not want to create an account": "U wilt geen account aanmaken",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "Het geselecteerde product is voor u apart gezet. U heeft {minutes} minuten om het proces te voltooien door uw persoonlijke informatie op de volgende pagina in te vullen.",
  "Your reservation is in progress!": "Uw reservering is in behandeling!",
  "not available": "niet beschikbaar",
  "remaining place": "resterende plaats|resterende plaatsen",
  "see availability": "zie beschikbaarheid",
  "Email Address": "E-mailadres",
  "Phone": "Telefoon",
  "Birthdate": "Geboortedatum",
  "ProductTypes": "Producttypen",
  "Sizes": "Maten",
  "Filter": "Filter",
  "Select a date": "Selecteer een datum",
  "Give us your opinion": "Geef ons uw mening",
  "Thank you for your review!": "Bedankt voor uw beoordeling!",
  "You can also review these products": "U kunt ook deze producten beoordelen",
  "Undo": "Ongedaan maken",
  "Redo": "Opnieuw",
  "Bold": "Vet",
  "Italic": "Cursief",
  "Strikethrough": "Doorhalen",
  "Paragraph": "Paragraaf",
  "Add Link": "Link toevoegen",
  "Remove Link": "Link verwijderen",
  "Headings": "Koppen",
  "Heading 2": "Kop 2",
  "Heading 3": "Kop 3",
  "Heading 4": "Kop 4",
  "Heading 5": "Kop 5",
  "Heading 6": "Kop 6",
  "Bullet List": "Opsommingsteken",
  "Numbered List": "Genummerde lijst",
  "Clear Formatting": "Opmaak wissen",
  "Overall Rating": "Algemene beoordeling",
  "Review title": "Beoordelingstitel",
  "Summarize your impression on the product": "Vat uw indruk van het product samen",
  "Your detailed product review": "Uw gedetailleerde productbeoordeling",
  "50 characters minimum": "50 tekens (minimaal)",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "Wat was uw indruk van het product tijdens het testen? Wat vond u leuk of niet leuk aan het product? Onder welke omstandigheden werd het product getest?",
  "50 characters (minimum)": "50 tekens (minimaal)",
  "Comments": "Opmerkingen",
  "Comments on the reception, the organization, the advice on the product…": "Opmerkingen over de ontvangst, de organisatie, het advies over het product…",
  "Would you recommend this product to a friend?": "Zou u dit product aanbevelen aan een vriend?",
  "Would you be ready to buy this product?": "Zou u bereid zijn dit product te kopen?",
  "First name or pseudo": "Voornaam of pseudoniem",
  "Your name / nickname is published with your review": "Uw naam / bijnaam wordt gepubliceerd met uw beoordeling",
  "I have read and I accept the terms and conditions": "Ik heb de algemene voorwaarden gelezen en accepteer deze",
  "of publication of the reviews": "van publicatie van de beoordelingen",
  "and": "en",
  "the privacy policy": "het privacybeleid",
  "Post Review": "Beoordeling plaatsen",
  "Very bad": "Zeer slecht",
  "Bad": "Slecht",
  "Average": "Gemiddeld",
  "Good": "Goed",
  "Great!": "Geweldig!",
  "Image caption": "Afbeelding bijschrift",
  "No": "Nee",
  "Yes": "Ja",
  "This site is protected by reCAPTCHA.": "Deze site wordt beschermd door reCAPTCHA.",
  "Google Privacy Policy": "Privacybeleid van Google",
  "Google Terms of Service": "Servicevoorwaarden van Google",
  "Read the full text": "Lees de volledige tekst",
}
